import { useState } from "react";
import LoginForm from "../components/LoginForm"
import styles from "../styles/ChangePasswordPage.module.css"


export default function Login() {

    // No hay recuperación autogestionada: con el segundo factor por correo,
    // Cognito no permite usar ese mismo correo para restablecer la contraseña,
    // así que el reset lo hace un administrador.
    const [showHelp, setShowHelp] = useState(false);

    return (
        <div className={styles.generalContainer}>
            <div className={styles.card}>
                <div className={styles.logoContainer}>
                <img src="images/cs-loginSoyMomoImage.svg" width={100} height={100} className={styles.momoImg} alt="SoyMomo logo"/>
                </div>


                <h1 className={styles.title}>Log in</h1>
                


                <LoginForm/>

                <button
                    type="button"
                    className={styles.helpToggle}
                    onClick={() => setShowHelp((open) => !open)}
                    aria-expanded={showHelp}
                >
                    ¿Olvidaste tu contraseña?
                </button>

                {showHelp && (
                    <p className={styles.helpBox}>
                        Pídele a un administrador de la plataforma que
                        restablezca tu contraseña.
                    </p>
                )}

                <img src="images/cs-loginSoyMomoLogo.svg" width={100} height={100} className={styles.logo} alt="logo"/>

            </div>
        </div>
    )
}
